import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ServiceLocator } from '../../app/ServiceLocator';
import { ContentActionNotification } from '../../commonInfra/contentActions/ContentActionNotification';
import { Messages } from '../../codegen/Localize';
import { IConnectedDevice } from '../../ts/ServerApi/types/IConnectedDevice';
import { ServerUsers } from '../../userManagement/services/resources/ServerUsers';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '../../ts/L10n/L10n';
import { openReactActionDialog } from '../../commonInfra/dialogs/ReactActionDialog';
import { ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState, ActionDialogBodyWithInlineErrorMessage } from '../../commonInfra/dialogs/ActionDialogBodyWithInlineErrorMessage';
import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';

const initialDialogState: ActionDialogBodyWithInlineErrorMessageState = {
};

export function showDeleteConnectedDeviceDialog(device: IConnectedDevice, userId: string): Promise<IResult>{
    const dialogText = Messages.confirmRemoveConnectedDevices({ NAME: L10n.elideIfLong(device.displayName) });
    const initialBodyProps: ActionDialogBodyWithInlineErrorMessageProps = {dialogMessage: dialogText};

    const dialogInstance = openReactActionDialog<ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState, IResult>({
        title: Messages.deleteMessage(),
        actionName: Messages.remove(),
        isActionDelete: true,
        action: (_, state, updateDialogState) => {
            return deleteConnectedDevice(updateDialogState, userId, device);
        },
        dialogWidth: TabDialogWidth.width375px,
        bodyComponent: ActionDialogBodyWithInlineErrorMessage,
        dismissDialogOnActionFailed: false,
        initialBodyProps,
        initialDialogState
    });
    return Promise.resolve(dialogInstance.result);
}

async function deleteConnectedDevice(
    updateDialogState: React.Dispatch<MergeOrUpdateStateAction<ActionDialogBodyWithInlineErrorMessageState>>,
    userId: string, device: IConnectedDevice): Promise<IResult> {
    const result = await ServerUsers.instance.deleteUserConnectedDevices(userId, [device.id]);
    if(result && result.errors && result.errors.length) {
        updateDialogState({errorMessage: Messages.errorUnknown()});
      return Promise.reject();
    } else {
        ContentActionNotification.displaySuccessToast(Messages.removeConnectedClientsSuccessful({ NAME: L10n.elideIfLong(device.displayName) }));
        return Promise.resolve(result);
    }

}
